export const SET_PLAN_INDEX = "SET_PLAN_INDEX"

export const setPlanIndex = (payload) => (dispatch) => {
    dispatch({
        type: SET_PLAN_INDEX,
        payload: payload,
    });
};